
@let _metadata = metadata();
@let _controller = controller();
@let _customData = this.customData();

<ng-container *ngIf="_metadata!=null && _controller != null && _customData != null">

    
    <div *ngFor="let sec of serverSectionErrors()" class="server-error d-flex align-items-start" >
        <div style="padding-right: 16px;">
            <mat-icon>error</mat-icon>
        </div>
        <div class="d-flex flex-column">
            <div style="padding-bottom: 8px;">
                Secció amb errors
            </div>
            <div class="d-flex align-items-center error-item " *ngFor="let err of sec.validationResult.entity.errors" style="gap:12px;">
                <div class="bullet"></div>
                <div>{{getErrorItemDesc(err)}}</div>
            </div>
        </div>
        
    </div>
    
    <div *ngFor="let sec of serverSectionErrors()" style="height: 16px;"></div>

    <app-form-instance  [controller]="_controller" [section]="_metadata" [customData]="_customData">
    
    </app-form-instance> 

    <mat-divider></mat-divider>
    
    <div class="d-flex justify-content-end  align-items-center  " style="padding-top: 27px;" >
        <!-- <button mat-stroked-button (click)="validate($event);">Validar</button>         -->
        <!-- <div style="flex:1 0 0;"></div> -->
        <!-- <div *ngIf="validForm==false">Hi han errors de validació al formulari</div> -->
    </div>
    
</ng-container>

